import type { ReactElement } from 'react'

import { IR_STOCK_ROUTE } from '@/utils/routes'

import { LinkCard } from '@/components/elements/LinkCard'
import { LinkCardList } from '@/components/elements/LinkCardList'
import { SectionTitle } from '@/components/elements/SectionTitle'
import { Spacer } from '@/components/elements/Spacer'
import { TitleLayout } from '@/components/layout'
import { Head } from '@/components/layouts/Head'
import { Layout } from '@/components/layouts/Ir'

export const StockPage = () => {
  return (
    <Layout>
      <SectionTitle color="normal" titleText="Stock Information" subTitleText="株式情報" />
      <Spacer h={{ sp: 70, pc: 120 }} />
      <LinkCardList>
        {IR_STOCK_ROUTE.subdirectories.map(
          ({ path, name, imagePath, ...rest }) => (
            <LinkCard
              link={path}
              title={name}
              imgPath={imagePath}
              {...rest}
              key={path}
            />
          )
        )}
      </LinkCardList>
    </Layout>
  )
}

StockPage.getLayout = (page: ReactElement) => {
  const breadCrumbs = [
    { name: 'ホーム', path: '/' },
    { name: '株主・投資家向け情報', path: '/ir' },
    { name: '株式情報', path: '' },
  ]

  return (
    <>
      <Head
        title="株式情報"
        description="トライアルホールディングスの株式情報を掲載しています。"
        ogp={{ url: 'ir/stock' }}
      />
      <TitleLayout
        title="Investor Relations"
        subTitle="株主・投資家向け情報"
        breadCrumbs={breadCrumbs}
      >
        {page}
      </TitleLayout>
    </>
  )
}
